import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthContext';
import TrainingsList from './TrainingsList';
import TrainingEditor from './TrainingEditor';
import CompletionMatrix from './CompletionMatrix';
import TrainingDetailView from './TrainingDetailView';
import UserDetailView from './UserDetailView';
import MetricsHub from './MetricsHub';
import SurveysAdminList from '../surveys/admin/SurveysAdminList';
import SurveyEditor from '../surveys/admin/SurveyEditor';
import SurveyResults from '../surveys/admin/SurveyResults';

const AdminPanel = () => {
  const { currentUser } = useAuth();
  const isAdmin = currentUser?.roles?.some((r) => r.id === 1 || r.name === 'Admin');

  if (!isAdmin) {
    return (
      <div className="p-8 flex items-center justify-center text-slate-200">
        <div className="p-6 rounded bg-slate-800 border border-slate-700">
          <h2 className="text-xl font-semibold mb-2">Access Denied</h2>
          <p className="text-slate-400">Admin privileges required.</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="hub" replace />} />
      <Route path="hub" element={<MetricsHub />} />
      <Route path="trainings" element={<TrainingsList />} />
      <Route path="trainings/:trainingId" element={<TrainingEditor />} />
      <Route path="matrix" element={<CompletionMatrix />} />
      <Route path="by-training" element={<TrainingDetailView />} />
      <Route path="by-user" element={<UserDetailView />} />
      <Route path="surveys" element={<SurveysAdminList />} />
      <Route path="surveys/:surveyId" element={<SurveyEditor />} />
      <Route path="surveys/:surveyId/results" element={<SurveyResults />} />
    </Routes>
  );
};

export default AdminPanel;
